export const tags = [
  "dashboard-actions",
  "dashboard-ai-insights",
  "dashboard-content",
  "dashboard-logins",
  "jnct-full-calendar",
  "login-details-modal",

  "rollup-manager",
  "rollup-modal",

  "submit-learnosity-modal",
  "subscribe-modal",
  "text-modal",
  "jnct-users-table",
  "jnct-video-error-overlay",

  "jnct-review-modal",
  "jnct-confirmation-modal",
  "jnct-move-to-modal",
  "chapter-modal",

  "jnct-mobile-header",
  "jnct-mobile-footer",

  "jnct-account",
  "jnct-course-notebook",
] as const;
